module.exports = __webpack_public_path__ + "static/media/chat_app.1e6f92b8.png";